define('OutSystems/ClientRuntime/ScreenStateCache',["require", "exports", "./Logger", "./ObjectExtensions"], function (require, exports, Logger, ObjectExtensions) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ScreenStateCache = void 0;
    var ScreenStateCache = (function () {
        function ScreenStateCache() {
        }
        ScreenStateCache.addKey = function (stateCacheKey) {
            this.cache[stateCacheKey] = {
                components: {},
            };
            this.cacheKeys.push(stateCacheKey);
            var deltaToRemove = this.cacheKeys.length - ScreenStateCache.MaxCacheSize;
            if (deltaToRemove > 0) {
                for (var i = 0; i < deltaToRemove; i++) {
                    this.removeKey(this.cacheKeys[i]);
                }
            }
        };
        ScreenStateCache.removeKey = function (stateCacheKey) {
            delete this.cache[stateCacheKey];
            this.cacheKeys.splice(this.cacheKeys.indexOf(stateCacheKey), 1);
        };
        ScreenStateCache.save = function (stateCacheKey, componentKey, state, customProperties) {
            if (!this.cache[stateCacheKey]) {
                this.addKey(stateCacheKey);
            }
            this.cache[stateCacheKey].components[componentKey] = {
                state: state,
                customProperties: customProperties,
            };
        };
        ScreenStateCache.load = function (stateCacheKey, componentKey) {
            var screenState = ScreenStateCache.loadScreenCache(stateCacheKey);
            return screenState ? screenState.components[componentKey] : null;
        };
        ScreenStateCache.loadScreenCache = function (stateCacheKey) {
            return this.cache[stateCacheKey] || undefined;
        };
        ScreenStateCache.clear = function (stateCacheKey) {
            var _this = this;
            if (!stateCacheKey) {
                this.cache = {};
                this.cacheKeys = [];
            }
            else if (this.cache[stateCacheKey]) {
                this.removeKey(stateCacheKey);
            }
            Logger.trace(this, function () {
                return "State cache contains " + Object.keys(_this.cache).length + " entries with a total size of " + ObjectExtensions.roughSizeOf(_this.cache) + " bytes";
            });
        };
        ScreenStateCache.inspect = function () {
            return {
                cache: this.cache,
                cacheKeys: this.cacheKeys,
            };
        };
        ScreenStateCache.MaxCacheSize = 20;
        ScreenStateCache.cache = {};
        ScreenStateCache.cacheKeys = [];
        return ScreenStateCache;
    }());
    exports.ScreenStateCache = ScreenStateCache;
});
//# sourceMappingURL=ScreenStateCache.js.map;
